import styled from 'styled-components';

export const CustomAPILoaderWrapper = styled.div`
    min-height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
